import React, { useRef, useState } from "react";
import { Menu, X } from "lucide-react";
import "./Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === "Escape" && menuOpen) {
      setMenuOpen(false);
      toggleRef.current?.focus();
    }
  };

  return (
    <nav className="navbar" aria-label="Main navigation" onKeyDown={handleKeyDown}>
      <div className="navbar__brand">
        <span className="navbar__eyebrow">
          <span className="navbar__eyebrow-line" />
          Chennai's Trusted Gold Buyers
        </span>
        <h1 className="navbar__logo">Durga Gold</h1>
      </div>

      <button
        ref={toggleRef}
        type="button"
        className="navbar__toggle"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        aria-controls="navigation-links"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
      </button>

      <ul
        id="navigation-links"
        className={`navbar__links${menuOpen ? " navbar__links--open" : ""}`}
        onClick={(event) => {
          if (event.target.closest("a")) setMenuOpen(false);
        }}
      >
        <li><a href="#why-us">Why Us</a></li>
        <li><a href="#process">Process</a></li>
        <li><a href="#contact">Get Quote</a></li>
        <li><a href="#reviews">Reviews</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <a href="tel:9884442716" className="navbar__phone">
        <svg
          className="navbar__phone-icon"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.36 11.36 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.36 11.36 0 0 0 .57 3.57 1 1 0 0 1-.25 1.02l-2.2 2.2z" />
        </svg>
        98844 42716
      </a>
    </nav>
  );
}
